<ng-container
  *ngIf="(isSupplyChannelToggleAvailable$ | async) || (roomChannelsEntities$ | async)?.length > 0"
>
  <ng-container *ngrxLet="status$ as status">
    <h2 class="algorithms-title">{{ '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.TITLE' | translate }}</h2>
    <div class="algorithms-grid">
      <!-- Pump Control -->
      <div class="toggle-wrapper flex flex-col gap-[24px]">
        <h3>
          {{ '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.PUMP_CONTROL.TITLE' | translate }}
        </h3>

        <div class="flex flex-col gap-[8px]" *ngIf="obngEcoControlEntries$ | async as obngEcoControlEntries; else e3PumpControl">
          <ng-container *ngIf="obngEcoControlEntries.length > 0; else e3PumpControl">
            <ng-container *ngFor="let entry of obngEcoControlEntries">
              <app-obng-src-settings-pump-control
                [ecoControl]="entry.ecoControl"
                [circuitId]="entry.circuitId"
              ></app-obng-src-settings-pump-control>
            </ng-container>
          </ng-container>
        </div>
        <ng-template #e3PumpControl>
          <div>
            <ng-container *ngFor="let pumpControlFeatures of listPumpControlFeatures$ | async">
              <app-e3-src-settings-pump-control
                [status]="status"
                [pumpControlIds]="pumpControlIds"
                [pumpControlFeatures]="pumpControlFeatures"
              ></app-e3-src-settings-pump-control>
            </ng-container>
          </div>
        </ng-template>
        <ng-container *ngIf="status | value2: featurePropertyKey.active as statusValue">
          <p *ngIf="statusValue === bool.True">
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.PUMP_CONTROL.SRC_ENABLED.DESCRIPTION'
                | translate
            }}
          </p>
          <p *ngIf="statusValue !== bool.True">
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.PUMP_CONTROL.SRC_DISABLED.DESCRIPTION'
                | translate
            }}
          </p>
        </ng-container>
      </div>

      <!-- ViCare Smart Climate Optimization -->
      <ng-container *ngIf="roomChannelsEntities$ | async as roomChannelsEntities">
        <div
          class="toggle-wrapper flex flex-col gap-[24px]"
          *ngIf="roomChannelsEntities.length > 0"
        >
          <h3>
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.VICARE_OPTIMIZATION.TITLE' | translate
            }}
          </h3>

          <div class="flex flex-col gap-[8px]">
            <app-src-smart-climate-optimization
              *ngFor="let roomChannelsEntity of roomChannelsEntities"
              [roomChannelsEntity]="roomChannelsEntity"
            ></app-src-smart-climate-optimization>
          </div>

          <p>
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.VICARE_OPTIMIZATION.DESCRIPTION'
                | translate
            }}
          </p>
        </div>
      </ng-container>

      <!-- Condensate Avoidance -->
      <ng-container *ngIf="condensateFeatures$ | async as condensateFeatures">
        <div *ngIf="condensateFeatures?.isEnabled" class="toggle-wrapper flex flex-col gap-[24px]">
          <h3>
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.CONDENSATE_AVOIDANCE.TITLE' | translate
            }}
          </h3>
          <app-src-settings-condensate-avoidance
            [status]="status"
            [condensateFeatures]="condensateFeatures"
          >
          </app-src-settings-condensate-avoidance>
        </div>
      </ng-container>

      <!-- Intelligent Heat Control -->
      <ng-container
        *ngIf="
          (obngOptimizedControlEntries$ | async)?.length > 0 ||
          (listFtdcFeatures$ | async)?.length > 0
        "
      >
        <div class="toggle-wrapper flex flex-col gap-[24px]">
          <h3>
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.INTELLIGENT_HEAT_CONTROL.TITLE'
                | translate
            }}
          </h3>

          <div
            class="flex flex-col gap-[8px]"
            *ngIf="
              obngOptimizedControlEntries$ | async as obngOptimizedControlEntries;
              else e3IntelligentHeatControl
            "
          >
            <ng-container
              *ngIf="obngOptimizedControlEntries.length > 0; else e3IntelligentHeatControl"
            >
              <ng-container *ngFor="let entry of obngOptimizedControlEntries">
                <app-obng-src-settings-intelligent-heat-control
                  [optimizedControl]="entry.optimizedControl"
                  [circuitId]="entry.circuitId"
                ></app-obng-src-settings-intelligent-heat-control>
              </ng-container>
            </ng-container>
          </div>
          <ng-template #e3IntelligentHeatControl>
            <div *ngIf="listFtdcFeatures$ | async as listFtdcFeatures">
              <app-e3-src-settings-intelligent-heat-control
                [status]="status"
                [ftdcFeatures]="listFtdcFeatures"
              ></app-e3-src-settings-intelligent-heat-control>
            </div>
          </ng-template>

          <p>
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.INTELLIGENT_HEAT_CONTROL.DESCRIPTION'
                | translate
            }}
          </p>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
